import sc from 'styled-components';

export const Container = sc.div`
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FormInfoWrapper = sc.div`
  p {
    font-size: 1.125rem;
    margin-bottom: 0.75rem;
  }

  ol {
    font-size: 14px;
  }

  span {
    display: inline-block;
    width: 160px;
  }
`;